export default __webpack_public_path__ + "img/select-524a02c3.svg";